import PropTypes from 'prop-types';

const displayName = 'GeneralFormPage';
const propTypes = {
  intl: PropTypes.object,
  deviceHeight: PropTypes.number,
  biller: PropTypes.object,
  formData: PropTypes.object,
  getBiller: PropTypes.func,
  getBillerPrefix: PropTypes.func,
  isLoading: PropTypes.bool,
  getForm: PropTypes.func,
  getBillerRecentTrx: PropTypes.func,
  updateFieldForm: PropTypes.func,
  setErrorState: PropTypes.func,
  setLoading: PropTypes.func,
  formValue: PropTypes.object,
  createCheckout: PropTypes.func,
  requestPay: PropTypes.func,
  match: PropTypes.shape({
    params: PropTypes.object,
  }),
  history: PropTypes.shape({
    goBack: PropTypes.func,
  }),
  trackEvent: PropTypes.func,
  getLatestTNC: PropTypes.func,
  getAgreementTNC: PropTypes.func,
  signatureAgreementTNC: PropTypes.func,
};

const defaultProps = {};

export default { displayName, propTypes, defaultProps };
